import React from 'react';
import { Presets as ReactPresets } from 'rete-react-plugin';
import { DataNode, Schemes } from './dataNode';

const DefaultConnection = ReactPresets.classic.Connection;

type ConnectionPayload = Schemes['Connection'];

type Editor = {
  getNode(id: string): { lockEdit?: boolean } | undefined;
};

/**
 * Returns a Connection component that adds class "connection-locked" when both
 * source and target nodes have lockEdit, so the connection can be styled.
 */
export function LockableConnectionComponent(
  editor: Editor,
  payload: ConnectionPayload,
): React.FC<{ data: ConnectionPayload }> {
  return function LockedConnection(props: { data: ConnectionPayload }) {
    const sourceNode = editor.getNode(payload.source) as DataNode | undefined;
    const targetNode = editor.getNode(payload.target) as DataNode | undefined;
    const isLocked = Boolean(sourceNode?.lockEdit && targetNode?.lockEdit);

    return (
      <div
        className={isLocked ? 'connection-locked' : ''}
        style={{ display: 'contents' }}
        data-connection-locked={isLocked ? 'true' : undefined}
      >
        <DefaultConnection {...props} />
      </div>
    );
  };
}
